import { filterSignalTypes } from "app/pages/sales-intelligence/modules/signals-api-webhook/utils/filterSignalTypes";
import SignalType from "app/pages/sales-intelligence/sub-modules/signals/models/core/SignalType";

import { signalsPerHook } from "../constants/signals-per-hook";
import type { IWebhookSubscriptionTableBaseModel } from "../types/row-data";

function createEmptySubscription(): IWebhookSubscriptionTableBaseModel {
    return {
        key: (Math.random() * 10000).toFixed(0),
        callbackUrl: "",
        signalsPerHook: signalsPerHook[0],
        signalTypes: filterSignalTypes(Object.values(SignalType)),
    };
}

export default createEmptySubscription;
